import core from '@js/core';
import comments from '@ui/comments';
import article from '@ui/article';
import voting from '@ui/user-rates/voting';
import ratings from '@ui/user-rates/ratings';
import share from '@ui/share';
import friendlyDate from '@ui/friendly-date';
import tooltipBox from '@ui/tooltip-box';
import checkbox from '@ui/checkbox';
import radioButton from '@ui/radio-button';
import smoothAnchor from '@ui/smooth-anchor';
import matchBar from '@ui/match-bar';
import poll from '@ui/poll/index';
import adBlockDetector from '@ui/ad-block-detector';

const ui = [comments, article, voting, ratings, friendlyDate, share, tooltipBox, checkbox, radioButton, smoothAnchor, matchBar, poll, adBlockDetector];

core.register(ui);



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/views/news.js